module.exports = __webpack_public_path__ + "img/SASB.20ce9fa6.png";